import React, { createContext, useReducer } from "react";
import Books from "../components/main/content/books/books";
import Certificates from "../components/main/content/certificates/Certificates";
import EmailMe from "../components/main/content/emailme/Emailme";
import Experiences from "../components/main/content/experiences/experiences";
import Fields from "../components/main/content/fields/fields";
import Skills from "../components/main/content/skills/skills";
import Tools from "../components/main/content/tools/tools";
import Reducer from "./reducer";

const initialState = {
  sections: [
    {
      id: 99,
      content: null,
      title: "Summary",
      href: "#summary",
      sid: "summary",
      active: true,
      pos: 0,
    },
    {
      id: 0,
      content: <Fields />,
      title: "Fields",
      href: "#fields",
      sid: "fields",
      active: false,
      pos: 0,
    },
    {
      id: 1,
      content: <Skills />,
      title: "Skills",
      href: "#skills",
      sid: "skills",
      active: false,
      pos: 0,
    },
    {
      id: 2,
      content: <Tools />,
      title: "Tools",
      href: "#tools",
      sid: "tools",
      active: false,
      pos: 0,
    },
    {
      id: 8,
      content: <Certificates />,
      title: "Certificates",
      href: "#certificates",
      sid: "certificates",
      active: false,
      pos: 0,
    },
    // {
    //   id: 3,
    //   content: <div></div>,
    //   title: "Educations",
    //   href: "#educations",
    //   sid: "educations",
    //   active: false,
    //   pos: 0,
    // },
    // {
    //   id: 4,
    //   content: <div></div>,
    //   title: "Latest Papers",
    //   href: "#papers",
    //   sid: "papers",
    //   active: false,
    //   pos: 0,
    // },
    {
      id: 5,
      content: <Experiences />,
      title: "Experiences",
      href: "#experiences",
      sid: "experiences",
      active: false,
      pos: 0,
    },
    {
      id: 6,
      content: <Books />,
      title: "Book Suggestion List",
      href: "#books",
      sid: "books",
      active: false,
      pos: 0,
    },
    {
      id: 7,
      content: <EmailMe />,
      title: "Email Me !",
      href: "#emailme",
      sid: "emailme",
      active: false,
      pos: 0,
    },
  ],
  error: null,
};

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);
export default Store;
